import { type ThemeConfig } from "antd"

const colors = {
  primary: "#2A7D8C",
  placeholder: "#9E9E9E",
  border: "#E5E7EB",
  // The container border is too faint to double as a control outline: an
  // unchecked box read as plain text until hovered. WCAG 1.4.11 wants 3:1.
  controlBorder: "#64748B"
}

export const defaultTheme: ThemeConfig = {
  token: {
    fontFamily: `'Manrope', sans-serif`,
    fontWeightStrong: 500,
    colorBorder: colors.border,
    colorBorderSecondary: colors.border,

    // borderRadius: 12,
    // radiusBase: 4,
    // controlRadius: 4,

    colorPrimary: colors.primary,

    // responsive title sizes
    fontSizeHeading1: "clamp(24px, 6vw, 38px)" as any,
    fontSizeHeading2: "clamp(20px, 5vw, 30px)" as any,
    fontSizeHeading3: "clamp(18px, 4vw, 24px)" as any,
    fontSizeHeading4: "clamp(16px, 3.5vw, 20px)" as any,
    fontSizeHeading5: "clamp(14px, 3vw, 16px)" as any,

    //
    colorTextPlaceholder: colors.placeholder,
    //
    colorTextDisabled: colors.placeholder
  },

  components: {
    Tag: {
      borderRadius: 12,
      borderRadiusXS: 12,
      borderRadiusSM: 12,
      borderRadiusLG: 12
    },
    Typography: {
      fontWeightStrong: 600,
      lineHeight: "20px" as any,
      titleMarginBottom: "0.2rem"
    },
    Progress: {
      defaultColor: colors.primary
    },
    Table: {
      bodySortBg: "#fafafa",
      borderColor: "#f0f0f0",
      // row
      rowHoverBg: "#fafafa",
      // header
      headerBg: "#F9FAFB",
      headerColor: "#000000",
      //
      footerBg: "#ffffff"
    },
    Layout: {
      bodyBg: "#F9FAFB",
      headerBg: "#FFFFFF"
      //headerPadding: '16px 32px',
    },
    Button: {
      defaultShadow: "none",
      primaryShadow: "none"
    },
    Checkbox: {
      colorBorder: colors.controlBorder
    }
  }
}
